import { content } from "html2canvas/dist/types/css/property-descriptors/content";
import React, { FC, HTMLAttributes, ReactNode } from "react";
import styled from "styled-components";

interface TooltipProps extends Omit<HTMLAttributes<HTMLDivElement>, "title"> {
  children: ReactNode;
  title: ReactNode;
  position?: "top" | "right" | "bottom" | "left";
}

const TooltipContent = styled.div<{ position: string }>`
  position: absolute;
  background-color: ${({ theme }) => theme.tooltipBackground};
  color: ${({ theme }) => theme.tooltipText};
  padding: .2em .5em;
  border-radius: 4px;
  font-size: .8em;
  white-space: nowrap;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 10;
  transform: translate(-50%, -50%);
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;

  ${({ position }) =>
    position === "top" &&
    `
    bottom: 100%;
    left: 50%;
    margin-bottom: 8px;
  `}

  ${({ position }) =>
    position === "right" &&
    `
    top: 50%;
    left: 100%;
    margin-left: 8px;
  `}

  ${({ position }) =>
    position === "bottom" &&
    `
    top: 100%;
    left: 50%;
    margin-top: 8px;
  `}

  ${({ position }) =>
    position === "left" &&
    `
    top: 50%;
    right: 100%;
    margin-right: 8px;
  `}
`;

const TooltipWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover ${TooltipContent} {
    opacity: 1;
    visibility: visible;
  }
`;

const Tooltip: FC<TooltipProps> = ({
  title,
  children,
  position = "top",
  ...props
}) => {
  return (
    <TooltipWrapper {...props}>
      {children}
      <TooltipContent position={position}>{title}</TooltipContent>
    </TooltipWrapper>
  );
};

export default Tooltip;
